/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import Box from './Box';

/**
 *
 * @param {object} props
 * @param {boolean | string} [props.flex]
 * @param {React.ReactNode} props.children
 */
export default function Col({ flex, ...rest }) {
  return (
    <Box
      sx={{
        paddingX: 'columnGap',
        boxSizing: 'border-box',
        flex: flex === true ? '1' : flex,
      }}
      {...rest}
    />
  );
}
